export const ActionTypes = {
  GET_LIST_KYC_HISTORY_START: "GET_LIST_KYC_HISTORY_START",
  GET_LIST_KYC_HISTORY_SUCCESS: "GET_LIST_KYC_HISTORY_SUCCESS",
  GET_LIST_KYC_HISTORY_ERROR: "GET_LIST_KYC_HISTORY_ERROR",
  GET_DETAIL_KYC_HISTORY_START: "GET_DETAIL_KYC_HISTORY_START",
  GET_DETAIL_KYC_HISTORY_SUCCESS: "GET_DETAIL_KYC_HISTORY_SUCCESS",
  GET_DETAIL_KYC_HISTORY_ERROR: "GET_DETAIL_KYC_HISTORY_ERROR",
};

export const actions = {
  getListKYCHistoryStart: (params, customerCode) => ({
    type: ActionTypes.GET_LIST_KYC_HISTORY_START,
    params,
    customerCode,
  }),
  getListKYCHistorySuccess: (data) => ({ type: ActionTypes.GET_LIST_KYC_HISTORY_SUCCESS, payload: data }),
  getListKYCHistoryError: (error) => ({ type: ActionTypes.GET_LIST_KYC_HISTORY_ERROR, payload: error }),
  getDetailKYCHistoryStart: (requestId) => ({ type: ActionTypes.GET_DETAIL_KYC_HISTORY_START, requestId }),
  getDetailKYCHistorySuccess: (data) => ({ type: ActionTypes.GET_DETAIL_KYC_HISTORY_SUCCESS, payload: data }),
  getDetailKYCHistoryError: (error) => ({ type: ActionTypes.GET_DETAIL_KYC_HISTORY_ERROR, payload: error }),
};
